import axios from "axios";
import Transaction_Refund from "./Transaction_Refund.class.js";

/**
 * @classdesc Les remboursements a effectuer pour une commande
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class Commande_Refund
 */
export default class Commande_Refund {
    id_commande;
    uuid;
    fee_payed_by = "orga";
    fee_amount = 1;
    prix;
    prix_total;
    taxe;
    statut;
    mail_owner;
    total_refundable = 0;
    amount_to_refund = 0;
    total_after_refund = 0;
    list_transactions = [];
    /**
     * Creates an instance of Commande_Refund.
     * @constructs
     * @kind function
     * @memberof Commande_Refund
     */
    constructor() {

    }

    async fetch() {
        let res = await axios.get("/administration/refund/get_commande.php?id=" + this.id_commande);
        if (res.data.error) {
            console.log(res.data.error);
        } else {
            await this.set(res.data);
        }
    }

    async set(data) {
        this.uuid = data.uuid;
        this.prix = data.prix;
        this.prix_total = data.prix_total;
        this.total_after_refund = data.prix_total;
        this.taxe = data.taxe;
        this.statut = data.statut;
        this.mail_owner = data.account.mail;
        await this.set_list_transactions(data.list_transactions);

    }
    async set_list_transactions(list_transactions) {
        this.list_transactions = [];
        for (let i = 0; i < list_transactions.length; i++) {
            let transaction = new Transaction_Refund();
            transaction.set(list_transactions[i]);
            await transaction.is_captured();
            this.list_transactions.push(transaction);
            if (transaction.captured && transaction.statut == "PAID") {
                this.total_refundable += parseFloat(transaction.prix);
            }
        }

    }

    calculate_amount_to_refund(uuid) {
        let amount_to_refund = 0;
        for (let i = 0; i < this.list_transactions.length; i++) {
            if (this.list_transactions[i].uuid == uuid) {

                if (this.list_transactions[i].amount_to_refund === undefined || this.list_transactions[i].amount_to_refund === "") {
                    this.list_transactions[i].amount_to_refund = 0;
                }
                if (parseFloat(this.list_transactions[i].amount_to_refund) > parseFloat(this.list_transactions[i].prix)) {
                    this.list_transactions[i].amount_to_refund = this.list_transactions[i].prix;
                }
                this.list_transactions[i].total_after_refund = parseFloat(this.list_transactions[i].prix) - parseFloat(this.list_transactions[i].amount_to_refund);
                this.list_transactions[i].total_after_refund = this.list_transactions[i].total_after_refund.toFixed(2);
            }
            amount_to_refund += parseFloat(this.list_transactions[i].amount_to_refund);
        }
        this.amount_to_refund = amount_to_refund;
        this.total_after_refund = parseFloat(this.prix_total) - parseFloat(this.amount_to_refund);
        this.total_after_refund = this.total_after_refund.toFixed(2);
    }

}